/**
 * KeyHints — the shortcut legend under the theater. The keys
 * themselves are bound by `useReviewShortcuts` through the session; this row
 * only advertises them, and steps aside while a frame is being marked up.
 */
const KEY_HINTS: { keys: string[]; label: string }[] = [
  { keys: ['Space'], label: 'play' },
  { keys: ['←', '→'], label: 'frame' },
  { keys: ['C'], label: 'capture' },
  { keys: ['F'], label: 'full view' },
  { keys: ['Enter'], label: 'send' },
];

export interface KeyHintsProps {
  hidden: boolean;
}

export function KeyHints({ hidden }: KeyHintsProps) {
  if (hidden) return null;

  return (
    <div className="mt-3 flex flex-wrap justify-center gap-3 text-[11px] text-muted-foreground" data-testid="key-hints">
      {KEY_HINTS.map((hint) => (
        <span key={hint.label}>
          {hint.keys.map((key) => (
            <kbd key={key} className="mr-[2px] rounded border border-b-2 border-border bg-muted px-[5px] py-px font-[inherit] text-[10px] text-muted-foreground">
              {key}
            </kbd>
          ))}
          {hint.label}
        </span>
      ))}
    </div>
  );
}
